
import EntityClick from './../../entity/entityClick';

export default class extends EntityClick {
  constructor(portal) {   
    super(portal, {
      'open-referral': 'openReferralModal',
      'referral-send': 'sendReferral',
      'referral-close': 'closeReferral',
    });
  }

  init() {

  }

  updateEmailContent() {
    const emailContent = document.getElementById('email-content');

    let friendName = 'Friend';
    if (document.getElementById('referral-name-first').value != '' || document.getElementById('referral-name-last').value != '') {
      friendName = document.getElementById('referral-name-first').value + ' ' + document.getElementById('referral-name-last').value;
    }

    let yourName = 'Your Friend';
    if ( document.getElementById('your-name-first').value != '' || document.getElementById('your-name-last').value != '') {
      yourName = document.getElementById('your-name-first').value + ' ' + document.getElementById('your-name-last').value;
    }

    emailContent.innerHTML = eh_portal.eh_templates.referal_template
      .replace(/<br>/g, '\n')
      .replace(/{recepient_name}/g, friendName)
      .replace(/{recipient_name}/g, friendName)
      .replace(/{sender_name}/g, yourName)
      .replace(/{firm_name}/g, eh_portal.eh_template_placeholders.firm_name)
      .replace(/{firm_link}/g, eh_portal.eh_template_placeholders.firm_link)
      .replace(/<a(.*)href="(.*)">(.*)<\/a>/g, (match, p1, p2, p3) => p3);
    
    document.getElementById('message-preview').style.display = 'block';
  }

  openReferralModal() {

    this.referralConfirm = window.jQuery.confirm({
      title: 'Refer our firm',
      content: `
          <p id="referral-warning">Warning</p>
          <br>
          <div id="pre-captcha">
          Your Friend <br>
          <div>
              <input id="referral-name-first" type="text" placeholder="First Name"  style="width:50%"><input id="referral-name-last" type="text" placeholder="Last Name"  style="width:50%">
          </div>
          <input id="referral-email" placeholder="Email Address" type="text">

          <br>
          <br>
          Your Name
          <div>
              <input id="your-name-first" type="text" placeholder="Your First Name"  style="width:50%"><input id="your-name-last" type="text" placeholder="Your Last Name"  style="width:50%">
          </div>

          <input id="your-email" placeholder="Your Email Address" type="text">
          <br><br>
          <div id="message-preview" style="">
            Message Preview<br>
            <div id="email-content" style="    border: none;
            font-size: 12px;
            background: #efefef;
            text-align: left;
            padding: 5px;"></div>
          </div>
          </div>

          <!-- Re-enable captcha when still getting too much spam
          <div id="message-captcha" style="display:none">
            <img style="    
              border-radius: 25px;
              border: 1px solid #f7f7f7;
              margin: 5px;"
            >
            <br>
            <p>To prevent spam, please enter the characters you see above.</p>
            <input type="hidden" id="refCaptchaChallenge">
            <input style="width: 50%; max-width: 200px" type="text" class="input-control" id="refCaptcha">
            <br><br><br>
          </div>
          -->

            `,
      onContentReady: () => {
        this.updateEmailContent();
        /** Re-enable captcha
        window.SpeedyAPI.get('hub/v2', 'RequestCaptcha', {}, (a) => {
            if (a.captcha != '') {   
              jQuery('#message-captcha img').attr('src', 'data:image/png;base64,' + a.captcha);
              jQuery('#message-captcha').show();
              document.getElementById('refCaptchaChallenge').value = a.challenge;

              startTime = a.delay;
            }
        });*/
        document.getElementById('referral-name-first').onkeyup = this.updateEmailContent;
        document.getElementById('referral-name-last').onkeyup = this.updateEmailContent;
        document.getElementById('referral-email').onkeyup = this.updateEmailContent;
    
        document.getElementById('your-name-first').onkeyup = this.updateEmailContent;
        document.getElementById('your-name-last').onkeyup = this.updateEmailContent;
    
        document.getElementById('referral-email').value = '';
        document.getElementById('referral-name-first').value = '';
        document.getElementById('referral-name-last').value = '';
    
        document.getElementById('your-email').value = '';
        document.getElementById('your-name-first').value = '';
        document.getElementById('your-name-last').value = '';
      },
      theme: 'leap-big',
      animation: 'scale',
      closeIcon: true,
      buttons: {
        'Send': {
          btnClass: 'export_confirmation',
          action: () => {
            this.sendReferral(this.referralConfirm);

            return false;
          },
        },
        'Cancel': {
          btnClass: 'edit_cancel',
        },
      },
    });
  }

  async sendReferral(modal) {
    const results = await this.handleReferral();
    if (results) {
      window.modal = modal;
      modal.$$Cancel.click();
      window.LeapUtil.notification('success', 'Message sent!');

      try {
        ga('send', 'event', 'portal', 'send-referral', window.location.hostname);
      } catch (e) {
        console.log('ga:send fail', e);
      }
    }
    
    return results;
  }

  handleReferral() {
    return new Promise(async (resolve, reject) => {
      const email = document.getElementById('referral-email').value.trim();
      const nameFirst = document.getElementById('referral-name-first').value.trim();
      const nameLast = document.getElementById('referral-name-last').value.trim();

      const yourEmail = document.getElementById('your-email').value.trim();
      const yourNameFirst = document.getElementById('your-name-first').value.trim();
      const yourNameLast = document.getElementById('your-name-last').value.trim();

      // const honeypot = document.getElementById('referral-mobile').value.trim();

      // /** 
      //  *  Don't even go to server, and just pretend it's all success.
      //  *  @link https://leapdev.atlassian.net/browse/WP-821
      //  */
      // if (honeypot.length > 0)
      // {
      //   resolve(true);
      //   return;
      // }

      /** Re-enable captcha
      const challenge = document.getElementById('refCaptchaChallenge').value.trim();
      const text = document.getElementById('refCaptcha').value.trim();
       */
      
      const params = {
        email,
        nameFirst,
        nameLast,

        yourEmail,
        yourNameFirst,
        yourNameLast,

        /**
         *  @link https://leapdev.atlassian.net/browse/WP-821
         */
        // honeypot,
        
        /** Re-enable captcha
        challenge,
        text, */
        
      };

      if (nameFirst.length == 0) {
        document.getElementById('referral-warning').innerHTML = 'Please provide your friends first name.';
        document.getElementById('referral-warning').style.display = 'block'
        resolve(false);
        return;
      }   
      
      if (nameLast.length == 0) {
        document.getElementById('referral-warning').innerHTML = 'Please provide your friends last name.';
        document.getElementById('referral-warning').style.display = 'block'
        resolve(false);
        return;
      }

      if (!nameFirst.match(/^[a-zA-ZÀ-ÖØ-öø-ÿ -]+$/)) {
        document.getElementById('referral-warning').innerHTML = 'Your friends first name is not valid.';
        document.getElementById('referral-warning').style.display = 'block'
        resolve(false);
        return;
      }

      if (!nameLast.match(/^[a-zA-ZÀ-ÖØ-öø-ÿ -]+$/)) {
        document.getElementById('referral-warning').innerHTML = 'Your friends last name is not valid.';
        document.getElementById('referral-warning').style.display = 'block'
        resolve(false);
        return;
      }

      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        document.getElementById('referral-warning').innerHTML = 'Please enter a valid email address for your friend.';
        document.getElementById('referral-warning').style.display = 'block'
        resolve(false);
        return;
      }      
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(yourEmail)) {

        document.getElementById('referral-warning').innerHTML = 'Please enter a valid email address for yourself.';
        document.getElementById('referral-warning').style.display = 'block'
        resolve(false);
        return;
      }

      
      if (!yourNameFirst.match(/^[a-zA-ZÀ-ÖØ-öø-ÿ -]+$/)) {
        document.getElementById('referral-warning').innerHTML = 'Your first name is not valid.';
        document.getElementById('referral-warning').style.display = 'block'
        resolve(false);
        return;
      }

      if (!yourNameLast.match(/^[a-zA-ZÀ-ÖØ-öø-ÿ -]+$/)) {
        document.getElementById('referral-warning').innerHTML = 'Your last name is not valid.';
        document.getElementById('referral-warning').style.display = 'block'
        resolve(false);
        return;
      }

      /** Re-enable captcha
      if (document.getElementById('message-captcha').getAttribute('src') && document.getElementById('refCaptcha').value == '') {
        document.getElementById('referral-warning').innerHTML = 'Please fill in the security code.';
        document.getElementById('referral-warning').style.display = 'block'

        document.getElementById('pre-captcha').style.display = 'none';
        document.getElementById('message-captcha').style.display = 'block';

        resolve(false);
        return;
      } */

      document.getElementById('referral-warning').innerHTML = '';
      document.getElementById('referral-warning').style.display = 'none'

      let results = await new Promise((resolve2, reject) => {
        window.SpeedyAPI.post('hub/v2', 'SendReferral', params, (refresults) => {
          resolve2(refresults);
        });
      });

      if (results.error) {
        /** Re-enable captcha
        await new Promise((resolve2, reject) => {
          window.SpeedyAPI.get('hub/v2', 'RequestCaptcha', {}, (a) => {
            jQuery('#message-captcha-load').hide();
            if (a.captcha != '') {   
              jQuery('#message-captcha').show();
              jQuery('#message-captcha img').attr('src', 'data:image/png;base64,' + a.captcha);
              document.getElementById('refCaptchaChallenge').value = a.challenge;
    
              document.getElementById('referral-warning').innerHTML = 'Please try again.';
              document.getElementById('referral-warning').style.display = 'block'
              document.getElementById('refCaptcha').value = '';    
            } else {
              document.getElementById('pre-captcha').style.display = 'block';
      
              jQuery('#message-captcha').hide();
            }
            resolve2(true);
          });
    
        }); */
        resolve(false);
        return;
      }

      resolve(results.success == 1);
    });
  }
}
